import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { contact, coverImageUrl, whatsappUrl } from '../content/siteContent';
import MapBackground from './decor/MapBackground';
import RoutePath from './decor/RoutePath';

const { FiArrowUpRight, FiMessageCircle, FiMapPin, FiClock, FiCheckCircle } = FiIcons;

function Hero() {
  return (
    <main className="hero" id="inicio">
      <MapBackground className="hero__map" />
      <RoutePath className="hero__route hero__route--one" />
      <RoutePath className="hero__route hero__route--two" reverse />
      <div className="hero__orb hero__orb--one" />
      <div className="container hero__grid">
        <motion.div className="hero__content" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}>
          <span className="eyebrow"><SafeIcon icon={FiMapPin} /> Mandados locales en Bonao</span>
          <h1>¿Tienes un mandao? <em>Nosotros vamos por ti.</em></h1>
          <p className="hero__lead">
            Comida, compras, documentos, paquetes y diligencias en Bonao.
            Dinos qué necesitas y Muchacho E’ Mandao se encarga.
          </p>
          <div className="hero__actions">
            <a className="button button--large" href={whatsappUrl()} target="_blank" rel="noreferrer">
              Pedir un mandao <SafeIcon icon={FiArrowUpRight} />
            </a>
            <a className="button button--outline button--large" href={whatsappUrl()} target="_blank" rel="noreferrer">
              <SafeIcon icon={FiMessageCircle} /> Escribir por WhatsApp
            </a>
          </div>
          <div className="hero__meta">
            <span><SafeIcon icon={FiCheckCircle} /> Mandados y diligencias</span>
            <span><SafeIcon icon={FiClock} /> Atención todos los días</span>
            <strong>{contact.phoneDisplay}</strong>
          </div>
        </motion.div>
        <motion.div
          className="hero__visual"
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.15, duration: 0.75 }}
        >
          <div className="hero__image-wrap">
            <img src={coverImageUrl} alt="Equipo de Muchacho E’ Mandao en Bonao" fetchPriority="high" />
          </div>
          <span className="hero__location"><SafeIcon icon={FiMapPin} /> Bonao, RD</span>
        </motion.div>
      </div>
      <a className="hero__scroll" href="#local">Descubre más <span>↓</span></a>
    </main>
  );
}

export default Hero;